angular.module('impactx.purchaserequest').controller('PurchaseRequestDetailCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    '$mdDialog',
    '$redirect',
    'basketTemplateMenu',
    'BackService',
    'ToastService',
    'TranslationService',
    'OpenGovernmentDataService',
    'ToolbarService',
    'CancellationService',
    'ApprovalOverviewService',
    'SubsequentPurchaseOrderDataService',
    'TemplateNameService',
    'LoadingDialogService',
    'AppConfiguration',
    'ConfirmationService',
    PurchaseRequestDetailController
]);

function PurchaseRequestDetailController($scope, dataGen, $routeParams, $mdDialog, $redirect, basketTemplateMenu,
                                         BackService, ToastService, TranslationService, OpenGovernmentDataService,
                                         ToolbarService, CancellationService, ApprovalOverviewService, SubsequentPurchaseOrderDataService,
                                         TemplateNameService, LoadingDialogService, AppConfiguration, ConfirmationService) {
    var self = this;
    $scope.scrollList = [];

    var prhId = $routeParams.id;
    var prsId = null;
    if ($routeParams.prsId) {
        prsId = $routeParams.prsId;
    }
    $scope.selectedPurchaseItems = [];

    $scope.getPageData = function () {
        dataGen.getData($scope, {id: prhId, prsId: prsId}, "/purchaserequest/view").then(function () {
            $scope.data.object.comments.internalComments.newComments = [];
            $scope.scrollList.push({id: 'timeline', label: $scope.trns.timeline});
            $scope.scrollList.push({id: 'approvalStatus', label: $scope.trns.approvalProcess});
            $scope.scrollList.push({id: 'internalComments', label: $scope.trns.internalComments});
            $scope.scrollList.push({id: 'externalComments', label: $scope.trns.externalComments});

            angular.forEach($scope.data.object.contracts, function (contract) {
                $scope.scrollList.push({id: 'csc' + contract.label, label: contract.value});
            });

            $scope.scrollList.push({id: 'basketSum', label: $scope.trns.sum});
            ToolbarService.setScrollMenu($scope.scrollList);
            defineButtons();
        });
    };

    $scope.getPageData();

    $scope.showItemComments = {value: false};

    self.toggleItemComment = function () {
        $scope.showItemComments.value = !$scope.showItemComments.value;
    };
    $scope.showHeaderComment = {value: false};
    self.toggleComment = function () {
        $scope.showHeaderComment.value = !$scope.showHeaderComment.value;
    };

    $scope.showComments = {value: false};
    $scope.showShare = {value: false};
    $scope.selectedSupplier = [];

    self.toggleSupplierComment = function () {
        $scope.showComments.value = !$scope.showComments.value;
    };

    $scope.showBuyerNoMinimizedBasket = AppConfiguration.get('showBuyerNoMinimizedBasket');

    self.toggleMinimized = function () {
        $scope.data.object.minimized = !$scope.data.object.minimized;
        dataGen.postAsForm({}, {minimized: $scope.data.object.minimized}, "/purchaserequest/saveminimized").then(
            angular.noop,
            function () {
                $scope.data.object.minimized = !$scope.data.object.minimized;
            }
        );
    };

    self.isMinimized = function () {
        return !!$scope.data.object.minimized;
    };

    self.isNotMinimized = function () {
        return !$scope.data.object.minimized;
    };

    self.toggleSupplierShare = function () {
        $scope.showShare.value = !$scope.showShare.value;
    };

    self.selectSupplier = function (event, supplier) {
        if (event.target.tagName != "MD-SELECT" &&
            (!event.target.parentNode.tagName || event.target.parentNode.tagName != "MD-SELECT-VALUE")
            && (!event.target.parentNode.tagName || !event.target.parentNode.parentNode.tagName || event.target.parentNode.parentNode.tagName != "MD-SELECT-VALUE")) {
            $scope.showComments.value = false;
            for (var i = 0; i < $scope.selectedPurchaseItems.length; i++) {
                $scope.selectedPurchaseItems[i].selected = false;
            }
            $scope.selectedPurchaseItems.splice(0, 1);

            if ($scope.selectedSupplier[0] !== supplier) {
                $scope.selectedSupplier[0] = supplier;
            }
            else {
                $scope.selectedSupplier.splice(0, 1);
            }
        }
    };

    self.cancelItems = function (event) {
        var selected = [];
        var ids = [];
        for (var i = 0; i < $scope.selectedPurchaseItems.length; i++) {
            if (ids.indexOf($scope.selectedPurchaseItems[i].id) < 0) {
                ids.push($scope.selectedPurchaseItems[i].id);
                if ($scope.selectedPurchaseItems[i].basketItemGroupId > 0) {
                    self.addItemsOfSameBasketItemGroup(ids, $scope.selectedPurchaseItems[i])
                }
            }
        }
        for (var j = 0; j < ids.length; j++) {
            selected.push({priId: ids[j]});
        }
        CancellationService.cancelItems(event, selected);
    };

    this.addItemsOfSameBasketItemGroup = function (ids, itemToAdd) {
        angular.forEach($scope.data.object.supplierHeaderList, function (supplierHeader) {
            angular.forEach(supplierHeader.requestItems, function (item) {
                if (item.basketItemGroupId === itemToAdd.basketItemGroupId) {
                    if (ids.indexOf(item.id) < 0) {
                        ids.push(item.id);
                    }
                }
            });
        });
    };

    self.cancelAll = function (event) {
        var selected = [];

        angular.forEach($scope.data.object.supplierHeaderList, function (supplierHeader) {
            angular.forEach(supplierHeader.requestItems, function (item) {
                selected.push({priId: item.id});
            });
        });
        CancellationService.cancelAll(event, selected);
    };

    this.createBasketTemplate = function() {
        TemplateNameService.showTemplateName([{prhId: prhId}], '/basket/template/beforecreatefromorder', event).then(function(answer){
            if(answer)
            {
                dataGen.postAsForm({},{items: [{prhId: prhId}], name: answer}, '/basket/template/createfromorder').then(function ()
                {
                    basketTemplateMenu.refreshAllTemplates();
                });
            }
        });
    }

    self.dispatchAll = function () {
        var prsIds = [];
        var i = 0;
        while (i < $scope.data.object.supplierHeaderList.length) {
            var supplierHeader = $scope.data.object.supplierHeaderList[i];
            if (supplierHeader.canDispatch) {
                prsIds.push(supplierHeader.id);
            }
            i++;
        }


        return dataGen.postAsForm({}, {prsIds: prsIds}, "/purchaserequest/dispatchmultipleprs").then(function () {
            BackService.back();
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
        });
    };

    self.dispatchPRS = function () {
        return dataGen.postAsForm({}, {prsId: $scope.selectedSupplier[0].id}, "/purchaserequest/dispatchprs").then(function () {
            BackService.back();
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
        });
    };

    self.denyDispatchAll = function () {
        var prsIds = [];
        var i = 0;
        while (i < $scope.data.object.supplierHeaderList.length) {
            var supplierHeader = $scope.data.object.supplierHeaderList[i];
            if (supplierHeader.canDenyDispatch) {
                prsIds.push(supplierHeader.id);
            }
            i++;
        }
        return dataGen.postAsForm({}, {prsIds: prsIds}, "/purchaserequest/denydispatchmultipleprs").then(function () {
            BackService.back();
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
        });
    };

    self.denyDispatchPRS = function () {
        return dataGen.postAsForm({}, {prsId: $scope.selectedSupplier[0].id}, "/purchaserequest/denydispatchprs").then(function () {
            BackService.back();
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
        });
    };

    self.releaseDialog = function (event) {
        var supplier = $scope.selectedSupplier[0];
        ConfirmationService.showConfirmationDialog(self.release, event, $scope.trns.release,
            $scope.trns.release, TranslationService.get('abort'), supplier.releaseQuestion);
    };

    self.release = function () {
        return dataGen.postAsForm({}, {prsId: $scope.selectedSupplier[0].id}, "/standstillinfo/release").then(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            BackService.back();
        });
    };

    self.rejectAwardDecisionDialog = function (event) {
        ConfirmationService.showConfirmationDialog(self.rejectAwardDecision, event, TranslationService.get('warning'),
            TranslationService.get('ok'), TranslationService.get('abort'), $scope.trns.rejectAwardDecisionQuestion);
    };

    self.rejectAwardDecision = function () {
        return dataGen.postAsForm({}, {id: $scope.selectedSupplier[0].id}, "/awarddecision/reject").then(function () {
            ToastService.openStandardToast($scope.trns.rejectAwardDecisionSuccessfully);
            BackService.back();
        });
    };

    self.redirectToApprovalModified = function () {
        var id = $scope.selectedPurchaseItems[0].id;
        $redirect.redirectTo(null, '/approvalmodifiedpri/' + id);
    };

    self.openOpenGovernmentDialog = function (event, supplier) {
        var ogdId = impactX.isDefined(supplier, 'ogd.id');
        if (ogdId) {
            OpenGovernmentDataService.openReadOnlyDialog(event, ogdId, supplier.contractName);
        }
    };

    self.canOnlyEditSPO = function (supplier) {
        //should normally be false, but just to make sure..
        return self.canEditSPO(supplier) && !supplier.canShowSubsequentPurchaseOrderData;
    };

    self.canEditSPO = function (supplier) {
        return supplier && supplier.canEditSPO;
    };

    self.editSPO = function (event, supplier) {
        SubsequentPurchaseOrderDataService.openEditDialog(event, supplier.id, "prs");
    }

    self.openSubsequentPurchaseOrderDataDialog = function (event, supplier) {
        if (self.canEditSPO(supplier)) {
            self.editSPO(event, supplier);
        } else {
            SubsequentPurchaseOrderDataService.openViewDialog(event, supplier.id, 0, 0);
        }
    };

    self.sendAttachments = function () {
        return dataGen.getData({}, {prsId: $scope.selectedSupplier[0].id}, "/purchaserequest/sendRequisitionAttachments").then(function (data) {
            if (data) {
                ToastService.openStandardToast(data.trns.attachmentsSend);
            }
        });
    };

    self.formatAddressValue = function (value) {
        if(value) {
            return value.replace(/,\s/g, '<br/>')
        }
        return '';
    }

    self.redirectApproval = function (event, entry) {
        var selectionData = {
            atiId: entry.atiId
        };
        $mdDialog.show({
            controller: 'RedirectUserCtrl',
            templateUrl: 'modules/approval/templates/redirectuser.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            fullscreen: true,
            bindToController: true,
            locals: {
                selectionData: selectionData
            }
        }).then(function (answer) {
            if (answer && answer.id) {
                var dataObj = {
                    atiId: entry.atiId,
                    usrId: answer.id
                }
                dataGen.postAsForm({}, dataObj, '/approval/redirect').then(function (data) {
                    if (data && data.trns) {
                        ToastService.openStandardToast(data.trns.successMessage)
                        $redirect.reload()
                    }
                });
            }
        });
    };

    self.showCateringDialog = function (event) {
        $mdDialog.show({
            controller: "CateringDialogRequestItemViewCtrl",
            controllerAs: "cateringDialogCtrl",
            templateUrl: 'modules/basket/templates/catering.dialog.html',
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                itemId: $scope.selectedPurchaseItems[0].id
            }
        });
    }

    self.resetApproval = function (event) {
        ConfirmationService.showConfirmationDialog(function () {
            dataGen.postAsForm({}, {type: "PRH", headerId: $scope.data.object.id}, '/approval/reset').then(function () {
                $redirect.reload();
            })
        }, event, TranslationService.get('warning'), TranslationService.get('ok'), TranslationService.get('abort'), $scope.trns.resetApprovalQuestion);
    }

    function defineButtons() {
        var buttonDefinition = [
            {
                icon: 'mdi-arrow-collapse-vertical',
                iconClass: 'icon-button-margin-adjust',
                tooltip: $scope.trns.minimize,
                type: 'icon',
                action: self.toggleMinimized,
                condition: self.isNotMinimized
            },
            {
                icon: 'mdi-arrow-expand-vertical',
                iconClass: 'icon-button-margin-adjust',
                tooltip: $scope.trns.expand,
                type: 'icon',
                action: self.toggleMinimized,
                condition: self.isMinimized
            },
            {
                label: $scope.trns.comments,
                action: self.toggleComment,
                type: 'dialogaction',
                condition: hasNoItemsSelected
            },
            {
                label: $scope.trns.comments,
                action: self.toggleItemComment,
                type: 'dialogaction',
                condition: hasItemsSelected
            },
            {
                label: $scope.trns.comments,
                action: self.toggleSupplierComment,
                type: 'dialogaction',
                condition: hasSupplierSelected
            },
            {
                label: $scope.trns.openSentBackBasket,
                linkFunction: getSendBackBasketLink,
                type: 'link',
                condition: canSendBasketBack
            },
            {
                label: $scope.trns.cancel,
                action: self.cancelItems,
                type: 'dialogaction',
                condition: canCancelItems
            },
            {
                label: $scope.trns.cancelAll,
                action: self.cancelAll,
                type: 'dialogaction',
                condition: canCancel
            },
            {
                label: $scope.trns.createTemplate,
                action: self.createBasketTemplate,
                type: 'dialogaction',
                condition: canCreateTemplate
            },
            {
                label: $scope.trns.dispatch,
                action: self.dispatchAll,
                type: 'dialogaction',
                condition: canDispatchAll
            },
            {
                label: $scope.trns.dispatch,
                action: self.dispatchPRS,
                type: 'dialogaction',
                condition: canDispatchPRS
            },
            {
                label: $scope.trns.deny,
                action: self.denyDispatchAll,
                type: 'dialogaction',
                condition: canDenyDispatchAll
            },
            {
                label: $scope.trns.deny,
                action: self.denyDispatchPRS,
                type: 'dialogaction',
                condition: canDenyDispatchPRS
            },
            {
                label: $scope.trns.releaseButton,
                action: self.releaseDialog,
                type: 'dialogaction',
                condition: canReleasePRS
            },
            {
                label: $scope.trns.rejectAwardDecision,
                action: self.rejectAwardDecisionDialog,
                type: 'dialogaction',
                condition: canRejectAwardDecisionPRS
            },
            {
                label: $scope.trns.approvalmodified,
                action: self.redirectToApprovalModified,
                type: 'dialogaction',
                condition: canRedirectToApproval
            },
            {
                label: $scope.trns.approvalDetails,
                action: openApprovalOverviewDialog,
                type: 'dialogaction'
            },
            {
                label: $scope.trns.sendAttachments,
                action: self.sendAttachments,
                type: 'dialogaction',
                condition: canSendAttachment,
                process: 'SendRequisitionAttachments'
            },
            {
                label: $scope.trns.viewCatering,
                action: self.showCateringDialog,
                type: 'dialogaction',
                condition: canViewCateringData
            },
            {
                label: $scope.trns.resetApproval,
                action: self.resetApproval,
                type: 'dialogaction',
                condition: canResetApproval
            },
            {
                label: $scope.trns.print,
                type: 'print',
                params: {
                    printToken: $scope.printTokens.request,
                }
            },
            {
                label: $scope.trns.editSPO,
                action: self.editSPO,
                type: 'dialogaction',
                condition: self.canOnlyEditSPO
            },
            {
                label: $scope.trns.shareStatusButton,
                action: self.toggleSupplierShare,
                type: 'dialogaction',
                condition: canEditShare
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function hasNoItemsSelected() {
        return !$scope.selectedPurchaseItems.length;
    }

    function hasItemsSelected() {
        return $scope.selectedPurchaseItems.length > 0;
    }

    function hasSupplierSelected() {
        return $scope.selectedSupplier.length > 0;
    }

    function canEditShare() {
        return hasSupplierSelected() && !$scope.selectedSupplier[0].statusEMailAddressesReadOnly && AppConfiguration.get("useShareOrderStatus");
    }

    function getSendBackBasketLink() {
        return "basket/" + $scope.data.object.basketId;
    }

    function canSendBasketBack() {
        return $scope.data.object.canOpenStoppedBasket;
    }

    function canCancelItems() {
        return hasItemsSelected() && canCancel();
    }

    function canCancel() {
        return $scope.data.object.canCancel;
    }

    function canCreateTemplate() {
        return $scope.data.object.canCreateTemplate;
    }

    function canDispatchAll() {
        return $scope.data.object.canDispatch && !$scope.selectedSupplier.length;
    }

    function canDispatchPRS() {
        return $scope.selectedSupplier.length == 1 && $scope.selectedSupplier[0].canDispatch;
    }

    function canDenyDispatchAll() {
        return $scope.data.object.canDenyDispatch && !$scope.selectedSupplier.length;
    }

    function canDenyDispatchPRS() {
        return $scope.selectedSupplier.length == 1 && $scope.selectedSupplier[0].canDenyDispatch;
    }

    function canReleasePRS() {
        return $scope.selectedSupplier.length == 1 && $scope.selectedSupplier[0].canRelease;
    }

    function canRejectAwardDecisionPRS() {
        return $scope.selectedSupplier.length == 1 && $scope.selectedSupplier[0].canRejectAwardDecision;
    }

    function canRedirectToApproval() {
        return $scope.selectedPurchaseItems.length == 1 && $scope.selectedPurchaseItems[0].showApprovalModifiedLink;
    }

    function canSendAttachment() {
        return $scope.selectedSupplier.length > 0 && $scope.selectedSupplier[0].isBANF;
    }

    function openApprovalOverviewDialog(event) {
        ApprovalOverviewService.openDialog(event, prhId);
    }

    function canViewCateringData() {
        return $scope.selectedPurchaseItems && $scope.selectedPurchaseItems.length === 1 && $scope.selectedPurchaseItems[0].isCatering;
    }

    function canResetApproval() {
        return $scope.data.object.canResetApproval;
    }

    this.addStatusEmailAddress = function (emailValue, supplier) {
        LoadingDialogService.start();
        var dataObj = {
            id: supplier.id,
            mail: emailValue
        };
        dataGen.postAsForm({}, dataObj, '/purchaserequest/statusmailaddress/supplier/add').then(function () {
                LoadingDialogService.stop();
                ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            },
            function () {
                LoadingDialogService.stop();
                supplier.statusEMailAddresses.pop();
            });
    }

    this.deleteStatusEmailAddress = function (emailValue, supplier) {
        LoadingDialogService.start();
        var dataObj = {
            id: supplier.id,
            mail: emailValue
        };
        dataGen.postAsForm({}, dataObj, '/purchaserequest/statusmailaddress/supplier/delete').then(function () {
                LoadingDialogService.stop();
                ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            },
            function () {
                LoadingDialogService.stop();
                supplier.statusEMailAddresses.push(emailValue);
            });
    }
}


